/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Aria_MainInputs */

const en_nav_aria_main = /** @type {(inputs: Nav_Aria_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

const pt_nav_aria_main = /** @type {(inputs: Nav_Aria_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegação principal`)
};

const es_nav_aria_main = /** @type {(inputs: Nav_Aria_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegación principal`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Nav_Aria_MainInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_aria_main = /** @type {((inputs?: Nav_Aria_MainInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Aria_MainInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_nav_aria_main(inputs)
	if (locale === "es") return es_nav_aria_main(inputs)
	return en_nav_aria_main(inputs)
});